<template>
  <div class="height-10 w-100 shadow-lg bg-brand-gradient">
    <div class="d-flex align-items-center container p-0">
      <div class="d-flex ml-0 page-logo bg-dark">
        <header-logo to="/" />
      </div>

      <change-language class="mr-0 ml-auto" />

      <div class="user-box">
        <router-link
          class="header-icon d-flex align-items-center justify-content-center"
          :to="{ name: $route.name === 'register' ? 'login' : 'register' }"
        >
          <span
            class="text-nowrap"
          >{{ $route.name === 'register' ? $t('buttons.log-in') : $t('buttons.sign-up') }}</span>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import HeaderLogo from './HeaderLogo';
import ChangeLanguage from '../ChangeLanguage';

// @vuese
// Nagłówek stron przed zalogowaniem
// @group Layout
export default {
  name: 'StartNavbar',
  components: { ChangeLanguage, HeaderLogo },
  computed: {
    ...mapState({
      appTitle: state => state.system.appTitle
    })
  }
};
</script>

<style >
a:link {
  text-decoration: none !important;
}
.page-logo img {
  height: 40px;
}
.logo-text {
  font-size: 1.2rem;
  color: black;
}
.bg-brand-gradient {
  background: rgb(140, 229, 137);
  background: -moz-linear-gradient(45deg, rgba(140, 229, 137, 1) 0%, rgba(33, 148, 220, 1) 100%);
  background: -webkit-linear-gradient(45deg, rgba(140, 229, 137, 1) 0%, rgba(33, 148, 220, 1) 100%);
  background: linear-gradient(45deg, rgba(140, 229, 137, 1) 0%, rgba(33, 148, 220, 1) 100%);
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#8ce589",endColorstr="#2194dc",GradientType=1);
}
</style>
